import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A straight sandbag breastwork filling the tile width along X: three long
// courses with staggered joints (each course split into offset boxes in two
// khaki tones) and a few individual bags laid along the top.
const BAG_A = "#a08d5f";
const BAG_B = "#7a6f4e";

const LEN = 0.88;
const COURSE_H = 0.105;
const DEPTH = 0.24;

// One course as two boxes split at `joint` (an x position), so joints stagger
// from course to course and the two tones alternate.
function courseAt(y: number, joint: number, flip: boolean): Part[] {
  const leftLen = joint + LEN / 2;
  const rightLen = LEN / 2 - joint;
  return [
    { geometry: new THREE.BoxGeometry(leftLen - 0.01, COURSE_H, DEPTH),
      color: flip ? BAG_B : BAG_A, position: [-LEN / 2 + leftLen / 2, y, 0] },
    { geometry: new THREE.BoxGeometry(rightLen - 0.01, COURSE_H, DEPTH),
      color: flip ? BAG_A : BAG_B, position: [LEN / 2 - rightLen / 2, y, 0] },
  ];
}

// One loose bag on top, slightly yawed so the crown reads as individual bags.
function topBag(x: number, color: string, yaw: number): Part {
  return {
    geometry: new THREE.BoxGeometry(0.19, 0.09, 0.2), color,
    position: [x, 3 * COURSE_H + 0.045, 0], rotation: [0, yaw, 0],
  };
}

export const sandbagWall = defineModel({
  id: "sandbag-wall",
  tiles: { w: 1, h: 1 },
  batchId: "wwi",
  author: "Fable 5",
  name: "Sandbag Wall",
  tags: ["prop", "wwi", "military", "defense", "fortification"],
  summary: "A straight breastwork of stacked khaki sandbags.",
  footprint: 0.45,
  parts(): Part[] {
    return [
      ...courseAt(COURSE_H / 2, -0.14, false),
      ...courseAt(COURSE_H * 1.5, 0.1, true),
      ...courseAt(COURSE_H * 2.5, -0.04, false),
      topBag(-0.32, BAG_A, 0.1),
      topBag(-0.11, BAG_B, -0.08),
      topBag(0.1, BAG_A, 0.06),
      topBag(0.31, BAG_B, -0.1),
    ];
  },
  animations: [],
});
